<script setup lang="ts">
import { createOutline } from "ionicons/icons";
import {
  IonButton,
  IonIcon,
  IonPage,
  IonContent,
  IonFooter,
  useIonRouter,
} from "@ionic/vue";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";

const { isMobile } = useWindowWidth();
const router = useIonRouter();

const navigate = (endpoint: string) => {
  window.location.href = endpoint;
};

const next = () => {
  const userStore = useUserStore();
  if (userStore.userIsLoggedIn) {
    router.push("/onboarding/new-event");
  } else {
    router.push("/onboarding/new-account");
  }
};
</script>
<template>
  <ion-page class="page_onboarding-introduction">
    <ion-content>
      <div class="introduction-container">
        <div v-if="isMobile" class="flex-desktop">
          <div>
            <figure class="page_onboarding-logo">
              <img src="@/assets/Checkin_isotipo_White.svg" />
            </figure>
          </div>
        </div>
        <div v-if="!isMobile" class="flex-desktop">
          <div
            class="flex-desktop"
            style="position: absolute; top: 23px; right: 40px"
          >
            <ion-button
              color="primary"
              style="margin-right: 20px"
              expand="block"
              @click="navigate('/login')"
              fill="outline"
              class="ion-margin-bottom"
            >
              LOG IN
            </ion-button>
            <ion-button
              color="primary"
              expand="block"
              @click="next()"
              class="ion-margin-bottom"
            >
              SIGN UP
            </ion-button>
          </div>
          <div style="width: 50vw">
            <div class="flex-desktop" style="color: white">
              <figure class="page_onboarding-logo" style="margin-right: 40px">
                <img src="@/assets/Checkin_isotipo_White.svg" />
              </figure>
              <div
                @click="navigate('https://beamian.com/lp-about-beamian')"
                style="margin-right: 60px; margin-top: 40px; cursor: pointer"
              >
                About us
              </div>
              <div
                @click="
                  navigate('https://info.beamian.com/need-more-than-check-in')
                "
                style="margin-top: 40px; cursor: pointer"
              >
                Need more?
              </div>
            </div>
            <div style="width: 550px; margin: 0 auto">
              <div class="introduction-title">
                Guest management <br />made easy
              </div>
              <div style="width: 260px">
                <ion-button
                  color="light"
                  expand="block"
                  @click="next()"
                  class="ion-margin-top"
                >
                  <div style="color: #7165e3; font-weight: bold">
                    GET STARTED
                  </div>
                </ion-button>
              </div>
              <div class="description-list" style="margin-top: 40px">
                <div>
                  <img src="@/assets/qr_code.svg" />
                  <div>Create, send and scan QR codes</div>
                </div>
                <div>
                  <img src="@/assets/form_registration.svg" />
                  <div>Easily build your event registration form</div>
                </div>
                <div>
                  <img src="@/assets/groups.svg" />
                  <div>Import guest mailing lists</div>
                </div>
                <div>
                  <img src="@/assets/checking.svg" />
                  <div>Get full attendance control</div>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 50vw; text-align: right">
            <img class="pcmobile" src="@/assets/checkin-pcmobile.png" />;
            <div
              class="flex-desktop"
              style="position: absolute; bottom: 20px; left: calc(75vw - 155px)"
            >
              <div>
                <a
                  href="https://apps.apple.com/us/app/check-in-by-beamian/id6444030004?itsct=apps_box_badge&amp;itscg=30200"
                  style="
                    display: inline-block;
                    overflow: hidden;
                    border-radius: 13px;
                    width: 187px;
                    height: 62px;
                    margin-top: 12px;
                  "
                  ><img
                    src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1672704000"
                    alt="Download on the App Store"
                    style="border-radius: 13px; width: 187px; height: 62px"
                /></a>
              </div>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.beamian.check&pcampaignid=web_share&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  ><img
                    alt="Get it on Google Play"
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    style="width: 225px"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
    <ion-footer v-if="isMobile">
      <div class="container">
        <section>
          <h1 class="text-white">Guest management made easy</h1>
          <p class="text-white">
            Import guest lists or easily build your event registration form.
            <br />
            <br />Create, send and scan QR codes. <br />
            <br />
            Get full attendance control.
          </p>
          <hr />
          <ion-button
            color="primary"
            expand="block"
            @click="next()"
            class="ion-margin-bottom"
          >
            <ion-icon slot="start" :icon="createOutline"></ion-icon>
            Start
          </ion-button>
          <p class="ion-text-center text-white">
            If you have an account you can login
            <router-link to="/login"><b>here</b></router-link
            >.
          </p>
        </section>
      </div>
    </ion-footer>
  </ion-page>
</template>

<style lang="scss">
.page_onboarding-introduction {
  padding-top: 3rem;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.22),
      rgba(0, 0, 0, 0.73)
    ),
    url("@/assets/onboarding-bg.png");
  background-size: cover;
  ion-content,
  .page_onboarding-logo {
    --background: none;
  }
  .page_onboarding-logo {
    margin: 0;
    padding: 0;
    width: 16rem;
  }

  ion-footer {
    background: none;
  }
}

.informations {
  width: 500px;
  margin-bottom: 40px;
  margin-left: 40px;
}

.layered-waves {
  height: 100vh;
  width: 100vw;
  transform: rotate(180deg);
}

.pcmobile {
  width: 45vw;
}

.description-list > div {
  color: white;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.description-list > div > img {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(166deg)
    brightness(102%) contrast(101%);
}

.description-list > div > div {
  margin-left: 10px;
}

.introduction-title {
  font-weight: bold;
  font-size: 3.5em;
  color: white;
  margin-top: 7vh;
}

@media (min-width: 768px) {
  .page_onboarding-introduction {
    padding-top: 0;
    background-image: url("@/assets/layered-waves.svg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: -15vw;
  }

  .introduction-container {
    // flex-direction: column;
    // justify-content: space-between;
    height: 100vh;
  }
}
</style>
